import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SubscriptionRecurrentFeeManual } from '@models/index';
import { EndpointParams } from '@models/utils/endpoint-params';
import { SubscriptionRecurrentFeeBuy } from '@models/buy/subscription/subscription-recurrent-fee-buy';
import { HttpService } from '@services/http.service';
import { PaymentCreateResponse } from '@models/buy/response/payment-create-response';
import { UpdatePaymentMethod } from '@models/payment-method/update-payment-method';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionsService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    create(subscriptionRecurrentFeeBuy: SubscriptionRecurrentFeeBuy): Observable<PaymentCreateResponse> {
        return this.post('subscription/member', this.defaultEndpointParams, subscriptionRecurrentFeeBuy);
    }

    updatePaymentMethod(idMemberFee: string, updatePaymentMethod: UpdatePaymentMethod): Observable<PaymentCreateResponse> {
        return this.put(`subscription/member/${idMemberFee}/paymentmethod`, this.defaultEndpointParams, updatePaymentMethod);
    }

    createManual(idSubscriptionPlanPriceManual: SubscriptionRecurrentFeeManual): Observable<any> {
        return this.post('payments/recurrentfee/member', this.defaultEndpointParams, idSubscriptionPlanPriceManual);
    }
}
